<template>
  <div
    class="form-container position-absolute top-50 start-50 translate-middle"
  >
    <!-- ------------ -->
    <!--    header    -->
    <!-- ------------ -->
    <div class="outer-area">
      <div class="auth-box text-center">
        <img
          class="mt-4"
          src="/bbLogo32Blue.png"
          alt="logo"
        />
        <p class="fw-lighter mt-4 mb-5 bb-app-heading">BATTLEBOARD</p>
        <!-- ------------ -->
        <!--    form      -->
        <!-- ------------ -->
        <form @submit.prevent="resend">
          <div class="form-group">
            <!-- ------------ -->
            <!--     email    -->
            <!-- ------------ -->
            <div class="form-floating mb-3">
              <input
                v-model="email"
                onkeyup="this.value = this.value.toLowerCase();"
                type="text"
                name="email"
                id="floatingEmail"
                placeholder="email"
                class="form-control"
                required
              />
              <label
                class="bb-float-label"
                for="floatingEmail"
                >Email</label
              >
            </div>
          </div>
          <!-- ------------ -->
          <!--    errors    -->
          <!-- ------------ -->
          <div
            v-for="err in errors"
            :key="err.id"
            class="bb-error-wrap mt-2"
          >
            {{ err }}
          </div>
          <!-- ------------ -->
          <!--    submit    -->
          <!-- ------------ -->
          <div class="d-grid gap-3">
            <button
              type="submit"
              :disabled="!email"
              class="btn btn-lg btn-primary mt-3 mb-3"
            >
              Resend
            </button>
          </div>
        </form>
        <!-- ------------------ -->
        <!--        login       -->
        <!-- ------------------ -->
        <div class="bb-vert-text-divider">
          <router-link
            class="bb-link"
            to="/login"
            >Login</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
//----------------------
// scripts
//----------------------
export default {
  name: 'resendEmailView',
  data() {
    return {
      email: '',
      errors: [],
    }
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    ...mapActions('auth', {
      resendEmail: 'resendEmail',
    }),
    ...mapMutations('auth', {
      setMessage: 'setMessage',
    }),
    //----------------------
    // resend email method
    //----------------------
    async resend() {
      this.errors = []
      const payload = {
        email: this.email,
      }
      //----------------------
      // api call
      //----------------------
      await this.resendEmail(payload)
        //----------------------
        // successful call
        //----------------------
        .then(() => {
          //----------------------
          // to go login screen
          //----------------------
          const message = {
            text: 'Verification email resent.\n\nIf you do not receive this email, use the link below.',
            link: {
              to: '/resendemail',
              label: 'Resend verification email',
            },
          }
          this.setMessage(message)
          this.$router.push({ name: 'logoutView' })
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          let error = window.bbErrorMsg(err)
          this.errors.push(error)
        })
    },
  },
  mounted() {
    document.body.className = 'bb-bg-partial'
  },
  unmounted() {
    document.body.className = 'bb-bg-full'
  },
}
</script>
